export default class Request {
    constructor(client) {
        this.client = client
    }

    invokeFacilioAPI(url, options) {
        const requestKey = 'request.invokeFacilioAPI'

        let params = {
            url: url,
            options: options
        }

        return this.client._postMessageWithPromise(requestKey, params)
    }

    invokeConnectorAPI(connector, url, options) {
        const requestKey = 'request.invokeConnectorAPI'

        let params = {
            connector: connector,
            url: url,
            options: options
        }

        return this.client._postMessageWithPromise(requestKey, params)
    }

    invokeExternalAPI(url, options) {
        const requestKey = 'request.invokeExternalAPI'

        let params = {
            url: url,
            options: options
        }

        return this.client._postMessageWithPromise(requestKey, params)
    }
}